/** A temperature is optional (null inherits the configured value) and otherwise lies in [0, 2]. */
function isTemperatureValid(value: number | null): boolean {
	if (value === null) {
		return true;
	}

	return Number.isFinite(value) && value >= 0 && value <= 2;
}

export default isTemperatureValid;
